import { useQuery } from "@tanstack/react-query";
import { coachApi } from "@bw/shared/api";
import type { ClubCoachProfilePublicResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The discoverable coach list is always facility-scoped. The query stays
 * disabled until a facility is selected; anonymous global coach enumeration is
 * intentionally not part of the product.
 */
export function useCoaches(
  params: {
    facilityId?: string;
  } = {},
) {
  return useQuery<ClubCoachProfilePublicResponse[]>({
    queryKey: queryKeys.coaches.list(
      params.facilityId,
      undefined,
      undefined,
      undefined,
    ),
    queryFn: () =>
      coachApi.listCoaches({
        facility_id: params.facilityId as string,
      }),
    enabled: Boolean(params.facilityId),
  });
}
